import { createAction } from 'redux-actions'

const prefix = 'PROMPT_HISTORY/'

export const fetchPromptHistoryStart = createAction(`${prefix}FETCH_START`)
export const fetchPromptHistorySuccess = createAction(`${prefix}FETCH_SUCCESS`)
export const fetchPromptHistoryError = createAction(`${prefix}FETCH_ERROR`)

export const createPromptHistoryEntryStart = createAction(`${prefix}CREATE_START`)
export const createPromptHistoryEntrySuccess = createAction(`${prefix}CREATE_SUCCESS`)
export const createPromptHistoryEntryError = createAction(`${prefix}CREATE_ERROR`)

export const deletePromptHistoryEntryStart = createAction(`${prefix}DELETE_START`)
export const deletePromptHistoryEntrySuccess = createAction(`${prefix}DELETE_SUCCESS`)
export const deletePromptHistoryEntryError = createAction(`${prefix}DELETE_ERROR`)

export const clearPromptHistoryStart = createAction(`${prefix}CLEAR_START`)
export const clearPromptHistorySuccess = createAction(`${prefix}CLEAR_SUCCESS`)
export const clearPromptHistoryError = createAction(`${prefix}CLEAR_ERROR`)
